export default __webpack_public_path__ + "static/media/logo-v2-fit.1d3de311.png";